import { orderTypeService } from '@/services';

export const orderTypeModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      error: null,
    },
  }),
  mutations: {
    load(state) {
      orderTypeService.getOrderTypes()
      .then((res) => {
        state.list.data = res
      })
      .catch((error) => {
        state.list.data = null
        state.list.error = error
      });
    },
  }
}
